exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".wordImagePasteErrorMessageContainer_2FoLYnpOppVZZIfbJzkrjb {\n  display: flex;\n  justify-content: center;\n}\n\n.wordImagePasteErrorMessage_3ygpMuX0Q1aavLU33_gy0t {\n  display: flex;\n  justify-content: center;\n  background-color: orange;\n  border-radius: 5px;\n  transition: all .5s, height .75s;\n  width: 100%;\n  position: relative;\n  text-align: center;\n  align-items: center;\n  padding-left: 15px;\n  padding-right: 30px;\n}", ""]);

// Exports
exports.locals = {
	"wordImagePasteErrorMessageContainer": "wordImagePasteErrorMessageContainer_2FoLYnpOppVZZIfbJzkrjb",
	"wordImagePasteErrorMessage": "wordImagePasteErrorMessage_3ygpMuX0Q1aavLU33_gy0t"
};